import classNames from 'classnames';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import styles from './styles.m.css';

const Image = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  const { typeDescription, url, graphicSize, comment } = message.payload;

  return (
    <MiniatureMessageLayout
      itleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={url}
      graphicSize={graphicSize}
      title={title}
      text={typeDescription}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    >
      {comment && (
        <TextRenderer
          isPlainText
          className={classNames(styles.text, textClassName)}
        >
          {comment}
        </TextRenderer>
      )}
    </MiniatureMessageLayout>
  );
};

export default Image;
